<template>
  <li role="listitem">
    <slot />
  </li>
</template>
